<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { mapActions } from "vuex";
const debounce = (fn, delay) => {
  let timer = null;
  return function () {
    let context = this;
    let args = arguments;
    clearTimeout(timer);
    timer = setTimeout(function () {
      fn.apply(context, args);
    }, delay);
  }
}

const _ResizeObserver = window.ResizeObserver;
window.ResizeObserver = class ResizeObserver extends _ResizeObserver {
  constructor(callback) {
    callback = debounce(callback, 16);
    super(callback);
  }
}
export default {
  name: "AdminLayout",
  mounted() {
    this.setDevice();
    window.onresize = () => {
      this.setDevice();
    };
  },
  methods: {
    ...mapActions({
      setDevice: "setDevice",
    }),
  },
};
</script>

<style lang="scss">
#app {
  font-family: Microsoft YaHei;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  color: #2c3e50;
}

body {
  margin: 0;
  padding: 0;
}

// 全局加滤镜
//html {
//  filter:grayscale(100%);
//  -webkit-filter:grayscale(100%);
//  -moz-filter:grayscale(100%);
//  -ms-filter:grayscale(100%);
//  -o-filter:grayscale(100%);
//  filter:progid:DXImageTransform.Microsoft.BasicImage(grayscale=1);
//  -webkit-filter:grayscale(1)
//}</style>
